import { render, staticRenderFns } from "./PlayerRenownReceived.vue?vue&type=template&id=81cd2eae&scoped=true&"
import script from "./PlayerRenownReceived.vue?vue&type=script&lang=js&"
export * from "./PlayerRenownReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cd2eae",
  null
  
)

export default component.exports